import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { MapPin, Bus, Tablet, Gamepad2 } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
export function SlideArrival() {
  const [imgError, setImgError] = useState(false);
  const [imgError2, setImgError2] = useState(false);
  return <div className="h-full w-full bg-[#EDF4F8] text-[#1B4F72] p-8 md:p-12 flex flex-col" data-id="element-77">
      <JourneyTimeline currentStage={2} data-id="element-78" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 border-l-4 border-[#6A9FBF] pl-6" data-id="element-79">
        <div className="flex items-center gap-3 mb-1" data-id="element-80">
          <span className="text-3xl" data-id="element-81">🧲</span>
          <h2 className="text-2xl font-bold text-[#1B4F72]" data-id="element-82">
            Arrival & Vicinity Activation
          </h2>
        </div>
        <p className="text-lg text-[#6A9FBF] font-medium" data-id="element-83">
          Goal: Capture attention before they reach the congress floor
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[0.8fr_1.2fr] gap-4 min-h-0" data-id="element-84">
        {/* Left Column: Tactics + Features + Novartis */}
        <div className="flex flex-col gap-3 overflow-auto" data-id="element-85">
          <motion.div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-86">
            <h3 className="text-sm font-bold text-[#1B4F72] mb-2 flex items-center gap-2" data-id="element-87">
              <span className="w-6 h-1 bg-[#6A9FBF] rounded-full" data-id="element-88"></span>
              Tactics
            </h3>
            <ul className="space-y-2" data-id="element-89">
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-90">
                <MapPin className="w-3.5 h-3.5 text-[#6A9FBF] mt-0.5 shrink-0" data-id="element-91" />
                <span className="text-gray-700 text-xs" data-id="element-92">
                  Geolocated Snaks™ via ride-share ads
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-93">
                <Bus className="w-3.5 h-3.5 text-[#6A9FBF] mt-0.5 shrink-0" data-id="element-94" />
                <span className="text-gray-700 text-xs" data-id="element-95">
                  Bus stop/outdoor ads with QR codes
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-96">
                <Tablet className="w-3.5 h-3.5 text-[#6A9FBF] mt-0.5 shrink-0" data-id="element-97" />
                <span className="text-gray-700 text-xs" data-id="element-98">
                  Rep-activated iPads: "Ready for a challenge?"
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-99">
                <Gamepad2 className="w-3.5 h-3.5 text-[#6A9FBF] mt-0.5 shrink-0" data-id="element-100" />
                <span className="text-gray-700 text-xs" data-id="element-101">
                  Mini-game or peer poll to spark curiosity
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#6A9FBF]/5 p-3 rounded-xl border border-[#6A9FBF]/10" variants={container} initial="hidden" animate="show" data-id="element-102">
            <h3 className="text-sm font-bold text-[#1B4F72] mb-2 flex items-center gap-2" data-id="element-103">
              <span className="w-6 h-1 bg-[#7CB9D8] rounded-full" data-id="element-104"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-2" data-id="element-105">
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-106">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-107" />
                <span className="text-gray-700 text-xs" data-id="element-108">
                  Teaser Snaks™ with{' '}
                  <strong className="text-[#1B4F72]" data-id="element-109">
                    Multiple Select Cue™
                  </strong>
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-110">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-111" />
                <span className="text-gray-700 text-xs" data-id="element-112">
                  QR-based{' '}
                  <strong className="text-[#1B4F72]" data-id="element-113">
                    scan-to-engage analytics
                  </strong>
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-114">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-115" />
                <span className="text-gray-700 text-xs" data-id="element-116">
                  Seamless CTA to drive footfall to booth
                </span>
              </motion.li>
            </ul>
          </motion.div>

          {/* Novartis example — compact */}
          <div className="flex flex-col items-center min-h-0" data-id="element-117">
            <div className="rounded-lg overflow-hidden shadow border border-gray-200 bg-gray-100 max-h-[16vh] max-w-[220px]" data-id="element-118">
              {imgError2 ? <div className="flex flex-col items-center justify-center w-full h-16 text-gray-400" data-id="element-119">
                  <Tablet className="w-6 h-6 mb-1 text-[#6A9FBF]/40" data-id="element-120" />
                  <p className="text-[8px]" data-id="element-121">Image not available</p>
                </div> : <img src="https://cdn.magicpatterns.com/uploads/5wZwAXkC7WxbfL1kWqcYQv/Screenshot_2026-02-11_at_18.27.04.png" alt="Novartis Congress Questionnaire" className="w-full h-full object-contain" onError={() => setImgError2(true)} data-id="element-122" />}
            </div>
            <p className="mt-1 text-[8px] text-[#5B8FAF] italic text-center" data-id="element-123">
              Novartis Questionnaire example
            </p>
          </div>
        </div>

        {/* Right Column: Geolocated Quiz image */}
        <motion.div className="flex flex-col items-center justify-center min-h-0" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-124">
          <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white max-h-full w-full" data-id="element-125">
            {imgError ? <div className="flex flex-col items-center justify-center w-full h-48 text-gray-400" data-id="element-126">
                <Tablet className="w-10 h-10 mb-2 text-[#6A9FBF]/40" data-id="element-127" />
                <p className="text-xs" data-id="element-128">Image not available</p>
              </div> : <img src="https://cdn.magicpatterns.com/uploads/qizvAsWXBHzKuyEm2o5JLr/Screenshot_2026-02-12_at_11.16.33.png" alt="Geolocated Quiz Challenge — 3 phone mockups showing ride-share quiz ads" className="w-full h-full object-contain" onError={() => setImgError(true)} data-id="element-129" />}
          </div>
          <p className="text-[9px] text-[#5B8FAF] italic text-center mt-2" data-id="element-130">
            Geolocated quiz ads via ride-share platforms
          </p>
        </motion.div>
      </div>
    </div>;
}